// extracted by mini-css-extract-plugin
export default {"modalOverlay":"rz-z","modalContent":"sz-z","header":"tz-z","close":"uz-z"};